module.exports = __webpack_public_path__ + "static/walking_statue_of_waterdeep_god_catcher_wdh-73a722da24babd133b984f6e20a489d1.webp";